import { useFormik } from 'formik';
import * as Yup from 'yup';
import classNames from 'classnames';
import { ErrorMessage, useAlert } from '@employ-engage/common-components';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ChangePasswordFormProps {}

export function ChangePasswordForm(props: ChangePasswordFormProps) {
  const { t } = useTranslation(['common']);
  const { Alert: PasswordChangedAlert } = useAlert({
    type: 'success',
    title: t('Saved'),
    message: t('Your password has been changed.'),
  });
  const { Alert: PasswordChangeFailedAlert } = useAlert({
    type: 'error',
    title: t('Something went wrong'),
    message: t('Your password could not be changed...please try again.'),
  });
  const { Alert: IncorrectPasswordAlert } = useAlert({
    type: 'error',
    title: t('Something went wrong'),
    message: t('Your entered the wrong password...please try again.'),
  });
  const {
    handleSubmit,
    errors,
    touched,
    dirty,
    values,
    handleChange,
    handleBlur,
  } = useFormik({
    initialValues: {
      currentPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
    },
    onSubmit: (values) => {
      // const user = auth.currentUser;

      // if (user) {
      //   signInWithEmailAndPassword(
      //     auth,
      //     user.email || '',
      //     values.currentPassword
      //   )
      //     .then((auth) => {
      //       updatePassword(auth.user, values.newPassword)
      //         .then(() => {
      //           firePasswordCHangedAlert(3000);
      //         })
      //         .catch((error) => {
      //           console.error('error: ', error);
      //           firePasswordCHangeFailedAlert(3000);
      //         });
      //     })
      //     .catch((error) => {
      //       console.error('error: ', error);
      //       fireIncorrectPasswordAlert(3000);
      //     });
      // }
    },
    validationSchema: Yup.object({
      currentPassword: Yup.string().required(t('Required')),
      newPassword: Yup.string().required(t('Required')).min(8, t('Too short')),
      newPasswordConfirm: Yup.string()
        .oneOf([Yup.ref('newPassword'), ''], t('Passwords must match'))
        .required(t('Required')),
    }),
  });

  const isSubmitDisabled = Object.keys(errors).length > 0 || !dirty;

  return (
    <form className="md:col-span-2" onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6">
        <div className="col-span-full">
          <label
            htmlFor="currentPassword"
            className="block text-sm font-medium leading-6 text-light-primaryText"
          >
            {t('Current password')}
          </label>
          <div className="mt-2">
            <input
              id="currentPassword"
              name="currentPassword"
              type="password"
              value={values.currentPassword}
              onChange={handleChange}
              onBlur={handleBlur}
              autoComplete="password"
              className="block w-full rounded-md border-0 bg-white/80 py-1.5 text-light-secondaryText shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
            />
          </div>
          {errors.currentPassword && touched.currentPassword && (
            <ErrorMessage
              errors={errors.currentPassword}
              touched={touched.currentPassword}
            />
          )}
        </div>

        <div className="col-span-full">
          <label
            htmlFor="newPassword"
            className="block text-sm font-medium leading-6 text-light-primaryText"
          >
            {t('New password')}
          </label>
          <div className="mt-2">
            <input
              id="newPassword"
              name="newPassword"
              type="password"
              value={values.newPassword}
              onChange={handleChange}
              onBlur={handleBlur}
              autoComplete="newPassword"
              className="block w-full rounded-md border-0 bg-white/80 py-1.5 text-light-secondaryText shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
            />
          </div>
          {errors.newPassword && touched.newPassword && (
            <ErrorMessage
              errors={errors.newPassword}
              touched={touched.newPassword}
            />
          )}
        </div>

        <div className="col-span-full">
          <label
            htmlFor="newPasswordConfirm"
            className="block text-sm font-medium leading-6 text-light-primaryText"
          >
            {t('Confirm password')}
          </label>
          <div className="mt-2">
            <input
              id="newPasswordConfirm"
              name="newPasswordConfirm"
              type="password"
              value={values.newPasswordConfirm}
              onChange={handleChange}
              onBlur={handleBlur}
              autoComplete="newPassword"
              className="block w-full rounded-md border-0 bg-white/80 py-1.5 text-light-secondaryText shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
            />
          </div>
          {errors.newPasswordConfirm && touched.newPasswordConfirm && (
            <ErrorMessage
              errors={errors.newPasswordConfirm}
              touched={touched.newPasswordConfirm}
            />
          )}
        </div>
      </div>

      <div className="mt-8 flex">
        <button
          type="submit"
          className={classNames(
            'rounded-md bg-indigo-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500',
            {
              'opacity-50 cursor-not-allowed': isSubmitDisabled,
            }
          )}
          disabled={isSubmitDisabled}
        >
          {t('Save')}
        </button>
      </div>
      <PasswordChangedAlert />
      <PasswordChangeFailedAlert />
      <IncorrectPasswordAlert />
    </form>
  );
}

export default ChangePasswordForm;
